import CustomForm from './custom_form.js';

class ResetPassword extends CustomForm {
  bindEvent() {
    $('#patient_email').on('keyup', (e) => this.validate(e.target.value))
  }

  validate(value) {
    this.isValid = value.length > 0
    const submitBtn = $(this.object).find(':input[type=submit]')
    this.isValid ? submitBtn.removeClass('disabled') : submitBtn.addClass('disabled')
  }
}

window.ResetPassword = ResetPassword

class EditPassword extends CustomForm {
  bindEvent() {
    $('#patient_password, #patient_password_confirmation').on('keyup', (e) => this.validate())
  }

  validate() {
    this.isValid = $(this.object).find('input[type=password]:empty').filter(function () {
        return $(this).val().length == 0
    }).length == 0;
    const submitBtn = $(this.object).find('input[type=submit]')
    this.isValid ? submitBtn.removeClass('disabled') : submitBtn.addClass('disabled')
  }
}

window.EditPassword = EditPassword
